export default __webpack_public_path__ + "static/media/invitation.74490aa9.png";